var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvalidKey = function SvgInvalidKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.796 27.608a2.077 2.077 0 1 0-2.938 2.938L32.313 36l-5.455 5.455a2.077 2.077 0 1 0 2.938 2.937l5.454-5.455 5.454 5.455a2.077 2.077 0 1 0 2.938-2.938L38.187 36l5.455-5.454a2.077 2.077 0 1 0-2.937-2.938l-5.455 5.455z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.067 26.846c1.266 1.266 3.129 1.872 4.746 1.101C41.063 25.92 44 21.595 44 16.587c0-6.95-5.658-12.586-12.638-12.586S18.723 9.636 18.723 16.588c0 3.22 1.47 5.561 1.47 5.561L4.909 37.372c-.686.683-1.646 2.459 0 4.098l1.763 1.756c.686.586 2.41 1.405 3.821 0l2.058-2.049c2.057 2.05 4.408.878 5.29-.293 1.47-2.049-.294-4.098-.294-4.098l.588-.585c2.822 2.81 5.29 1.17 6.172 0 1.47-2.05 0-4.098 0-4.098-.173-.345-.397-.588-.59-.797-.483-.525-.396-.963-.102-1.378.358-.504.5-1.125.418-1.738a3.692 3.692 0 0 1 6.27-3.106zm3.704-10.258c0 2.425-1.974 4.39-4.41 4.39-2.434 0-4.408-1.965-4.408-4.39s1.974-4.39 4.409-4.39 4.409 1.965 4.409 4.39",
    clipRule: "evenodd"
  })));
};
export default SvgInvalidKey;